import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

import PurchaseReferedHeader from '../components/common/headers/common/purchase-refered-header'
import {removeFromPurchaseRefered} from '../actions'
import {getCartTotal} from '../services'
import store from '../store';
import AuthService from "../components/services/auth.service";
import ApiService from "../components/services/api.service";

const removeFromPurchaseReferedItem = item=>{
    //store.dispatch(removeFromPurchaseRefered(item))

    let body = {
        "idPurchase": item.id,
        "id_user": item.id_user,
    }
    var user = AuthService.getCurrentUser();
    if(item.id > 0){
        ApiService.postCancelPurchase(user.token, body).then(
            (res) => {
                if(res && res.status == 'success'){
                    store.dispatch(removeFromPurchaseRefered(item))
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }
    
        
}

const PurchaseReferedContainer = ({purchaseReferedList, symbol, removeFromPurchaseRefered, logo}) => (
     <li  className="onhover-div "><div className="cart-qty-cls cart-refer-qty">{purchaseReferedList.length}</div>
            <div><Link to={`${process.env.PUBLIC_URL}/referred-orders`} >
                <svg
                    width="20" height="20" viewBox="42 40 286 386"
                    preserveAspectRatio="xMidYMid meet"
                    fill={logo=='ver_logo.png' ? '#F8EEE1' : '#161616'}
                    role="img" aria-label="referidos"
                >
                    {/* Mano (contorno). El trazado viene de un SVG exportado a 1254x1254
                        con el dibujo en la esquina, por eso el viewBox está ajustado a él. */}
                    <g transform="translate(0 1254) scale(0.1 -0.1)" stroke="none">
                        <path d="M830 12093 c-183 -19 -327 -161 -360 -353 -8 -46 -10 -385 -7 -1150 4 -1184 2 -1141 63 -1325 117 -354 349 -628 673 -793 175 -89 283 -124 463 -147 204 -27 384 -14 573 40 238 69 424 179 603 358 190 188 310 410 373 692 23 100 23 105 26 1090 3 698 1 1009 -7 1054 -24 138 -116 258 -245 322 -64 31 -74 33 -174 33 -77 0 -119 -5 -155 -18 -117 -43 -211 -136 -257 -254 -21 -51 -23 -78 -27 -278 l-4 -221 -61 26 c-55 23 -76 26 -177 26 -128 0 -181 -16 -268 -83 l-44 -34 -39 32 c-76 60 -143 84 -254 88 -87 3 -109 1 -167 -21 l-68 -25 0 262 c0 292 -7 361 -44 441 -31 68 -110 153 -173 187 -72 39 -167 59 -243 51z m126 -242 c48 -22 87 -70 103 -126 9 -29 11 -258 9 -820 l-3 -780 -130 -6 c-100 -4 -143 -10 -185 -27 -30 -12 -56 -22 -58 -22 -1 0 -1 375 0 834 l3 834 30 44 c58 82 145 108 231 69z m1922 -166 c47 -20 78 -50 105 -100 l22 -40 0 -980 c0 -1106 1 -1094 -76 -1291 -80 -205 -218 -386 -393 -517 -269 -199 -634 -270 -972 -188 -453 110 -790 481 -859 946 -29 196 -15 269 64 337 67 57 87 59 476 56 l351 -3 49 -32 c69 -44 98 -91 103 -163 5 -72 -9 -115 -53 -167 -47 -55 -100 -75 -218 -81 l-98 -5 3 -101 3 -101 69 -3 c170 -7 296 38 393 142 59 62 113 167 113 217 0 16 4 19 18 14 114 -49 264 -44 376 12 65 33 146 111 179 171 56 104 57 109 57 942 0 484 4 778 10 801 6 20 27 56 48 78 58 66 151 88 230 56z m-1257 -730 c23 -17 52 -48 63 -70 20 -38 21 -57 24 -417 2 -208 2 -378 0 -378 -2 0 -19 5 -38 11 -19 7 -111 14 -205 18 l-170 6 0 355 c0 349 0 356 22 397 42 78 108 114 200 110 50 -2 71 -9 104 -32z m615 14 c54 -26 100 -77 113 -126 15 -52 15 -845 0 -897 -6 -22 -29 -56 -53 -81 -125 -124 -334 -57 -366 118 -7 36 -10 204 -8 455 3 384 4 398 25 437 41 78 102 114 192 115 36 0 70 -7 97 -21z"/>
                    </g>
                </svg>
            </Link></div>
        <ul className="show-div shopping-cart shopping-cart-ref" id="shopping-cart-ref">
            { purchaseReferedList.map((item,index) => (
                <PurchaseReferedHeader key={index} item={item} symbol={<img src={`${process.env.PUBLIC_URL}/assets/images/icon/credit.png`} alt="" className="img-fluid" style={{width: 'auto',height: 'auto', bottom: '2px'}}/>} removeFromPurchaseRefered={() => removeFromPurchaseReferedItem(item)}  />
            ))}
            {(purchaseReferedList.length > 0) ?
                <div>
            
            <li>
                <div className="buttons">
                    <Link to={`${process.env.PUBLIC_URL}/referred-orders`} className="view-cart">Ver compras de usuarios</Link>
                    
                </div>
            </li></div>
                    :
            <li><h5>No hay compras de usuarios actualmente.</h5></li>}
        </ul>

    </li>
)


function mapStateToProps(state) {
    return {
        purchaseReferedList: state.purchaseReferedList.purchaseRefered,
        total: 0,//getCartTotal(state.purchaseReferedList.purchaseRefered),
        symbol: <img src={`${process.env.PUBLIC_URL}/assets/images/icon/credit.png`} alt="" className="img-fluid" style={{width: 'auto',height: 'auto', bottom: '2px'}}/>,//'S/ ',
    }
}

export default connect(mapStateToProps, {removeFromPurchaseRefered})(PurchaseReferedContainer);
//export default PurchaseReferedContainer;
